import { render, staticRenderFns } from "./DashboardResetPasswordStep1.vue?vue&type=template&id=1ccd675c&"
import script from "./DashboardResetPasswordStep1.vue?vue&type=script&lang=js&"
export * from "./DashboardResetPasswordStep1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports